import { MutableRefObject, ReactElement, useEffect } from 'react';
import { Box, ContextMenu, ContextMenuContent, ContextMenuTrigger } from '@cad-arc';
import { useMouseClickPosition } from '../hooks/use-mouse-click-position';
import { EsriMapContextMenuEntityTypeEnum } from '../types';

type SelectedEntityContextMenuProps = {
    mapRef: MutableRefObject<HTMLDivElement | null>;
    selectedContextMenuEntityType?: EsriMapContextMenuEntityTypeEnum;
    contextMenuEntityId?: number;
    closeEntityContextMenu: () => void;
    renderEventContextMenuComponent: (eventId: number) => JSX.Element;
    renderUnitContextMenuComponent: (unitId: number) => JSX.Element;
};

const CONTEXT_MENU_TRIGGER_ELEMENT_ID = 'context-menu-trigger-element';

export const SelectedEntityContextMenu = ({
    mapRef,
    selectedContextMenuEntityType,
    contextMenuEntityId,
    closeEntityContextMenu,
    renderEventContextMenuComponent,
    renderUnitContextMenuComponent,
}: SelectedEntityContextMenuProps): ReactElement | null => {
    const { mouseClientX, mouseClientY } = useMouseClickPosition(mapRef);

    useEffect(() => {
        const triggerElement = document.getElementById(CONTEXT_MENU_TRIGGER_ELEMENT_ID);
        const mouseHaveCoordinates = mouseClientX !== null && mouseClientY !== null;

        if (!!selectedContextMenuEntityType && triggerElement && mouseHaveCoordinates) {
            const newRightClickEvent = new MouseEvent('contextmenu', {
                bubbles: true,
                clientX: mouseClientX,
                clientY: mouseClientY,
            });

            // simulate right-click on the ContextMenuTrigger element
            triggerElement.dispatchEvent(newRightClickEvent);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedContextMenuEntityType]);

    if (!selectedContextMenuEntityType || !contextMenuEntityId) {
        return null;
    }

    return (
        <ContextMenu
            onOpenChange={(open) => {
                !open && closeEntityContextMenu();
            }}
        >
            <ContextMenuTrigger>
                <Box id={CONTEXT_MENU_TRIGGER_ELEMENT_ID} />
            </ContextMenuTrigger>
            <ContextMenuContent>
                {selectedContextMenuEntityType === EsriMapContextMenuEntityTypeEnum.EVENT &&
                    renderEventContextMenuComponent(contextMenuEntityId)}
                {selectedContextMenuEntityType === EsriMapContextMenuEntityTypeEnum.UNIT &&
                    renderUnitContextMenuComponent(contextMenuEntityId)}
            </ContextMenuContent>
        </ContextMenu>
    );
};
